import { render, staticRenderFns } from "./ProjectEditOptionSettingsTab.vue?vue&type=template&id=25642e6e"
import script from "./ProjectEditOptionSettingsTab.vue?vue&type=script&lang=ts"
export * from "./ProjectEditOptionSettingsTab.vue?vue&type=script&lang=ts"
import style0 from "./ProjectEditOptionSettingsTab.vue?vue&type=style&index=0&id=25642e6e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports